import { addTransactionIdToSteps } from '@common/prosemirror/collab/step';
import { Plugin, PluginKey, Transaction } from 'prosemirror-state';
import { v4 as uuidv4 } from 'uuid';

export const TransactionIdPluginKey: PluginKey = new PluginKey('transaction-id');

/**
 * Creates a ProseMirror plugin that adds a transaction id to each step in the transactions.
 * Should be one of the (if not the) last plugin added to ProseMirror so that the same transaction id is used on all transactions in the group.
 * @returns The ProseMirror plugin.
 */
export function transactionIdPlugin(): Plugin {
  return new Plugin({
    key: TransactionIdPluginKey,

    appendTransaction(transactions: Transaction[]): Transaction | null | undefined {
      // Add a transaction id to each step in the transactions
      const transactionId = uuidv4();
      transactions.forEach(transaction => {
        addTransactionIdToSteps(transaction.steps, transactionId);
      });

      return;
    }
  });
}
